import { render, staticRenderFns } from "./ReservedHistory.vue?vue&type=template&id=480c58c0&scoped=true&"
import script from "./ReservedHistory.vue?vue&type=script&lang=js&"
export * from "./ReservedHistory.vue?vue&type=script&lang=js&"
import style0 from "./ReservedHistory.vue?vue&type=style&index=0&id=480c58c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480c58c0",
  null
  
)

export default component.exports